import { useLayoutEffect } from 'react';

var index = useLayoutEffect ;

export { index as default };
//# sourceMappingURL=use-isomorphic-layout-effect.browser.esm.js.map
